import { ICreateServiceState } from "./reducers/createService";
import { IEditServiceState } from "./reducers/editService";
import { IScheduledServiceState } from "./reducers/scheduledServices";
import { IEquipmentState } from "./reducers/equipments";
import { IDataExportsState } from "./reducers/dataExports";
import { IServiceDraftsState } from "./reducers/serviceDrafts";

export interface RootState {
  createService: ICreateServiceState,
  editService: IEditServiceState,
  scheduledServices: IScheduledServiceState,
  equipments: IEquipmentState,
  dataExports: IDataExportsState,
  serviceDrafts: IServiceDraftsState,
}

export enum EAccessRole {
  admin = "admin",
  analyst = "analyst",
  contractor = "contractor",
}
